import React, { useEffect, useState } from "react";
import styles from "./DeliveryInformation.module.css";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import AddressSearchResultsModal from "./AddressResults";

const options = [
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NT", label: "Northwest Territories" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon" },
];

function DeliveryForm(props) {
  const [addresses, setAddresses] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    city: "",
    addressId: "",
    province: "",
    country: "CA-CANADA",
    zip: "",
  });
  const [searchValue, setSearchValue] = useState("");
  const [searchResultsModalOpen, setSearchResultsModalOpen] = useState(false);

  useEffect(() => {
    props.onChange(formData);
    //eslint-disable-next-line
  }, [formData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "name" && value !== "custom") {
      const serchedAddress = addresses.find((i) => i._id === value);
      setFormData({
        addressId: serchedAddress.addressId,
        address: serchedAddress.address,
        city: serchedAddress.city,
        name: serchedAddress.name,
        province: serchedAddress.province,
        zip: serchedAddress.zip,
        country: "CA",
      });
      setFormData((prevData) => ({
        ...prevData,
        [id]: id,
      }));
    }
    if (id === "name" && value === "custom") {
      setFormData({
        name: "",
        address: "",
        city: "",
        province: "",
        country: "CA-CANADA",
        zip: "",
      });
    }
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleAddressIdChange = async (data) => {
    setSearchResultsModalOpen(false);
    setSearchValue(data.addressId);
    setFormData({
      addressId: data.addressId,
      address: data.address,
      city: data.city,
      name: data.name,
      province: data.province,
      zip: data.zip,
      country: "CA",
    });
  };

  return (
    <>
      <form className={styles.container}>
        <div className={styles.heading}>
          <h2>Delivery Information</h2>
        </div>
        <div className={styles.controls}>
          <label htmlFor="name">Address ID</label>
          <div className={styles.search}>
            <input
              type="text"
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Address ID"
              value={searchValue}
            />
            <button
              onClick={(e) => {
                e.preventDefault();
                setSearchResultsModalOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>
        </div>
        <div className={styles.controls}>
          <label htmlFor="zip">ZIP</label>
          <input
            type="text"
            id="zip"
            onChange={handleInputChange}
            required
            placeholder="Zip Code"
            value={formData.zip}
          />
        </div>
        <div className={styles.controls}>
          <label htmlFor="Address">Address</label>
          <textarea
            id="address"
            onChange={handleInputChange}
            required
            placeholder="Address"
            value={formData.address}
          />
        </div>
        <div className={styles.controls}>
          <label htmlFor="city">City</label>
          <input
            id="city"
            type="text"
            onChange={handleInputChange}
            required
            placeholder="City"
            value={formData.city}
          />
        </div>
        <div className={styles.controls}>
          <label htmlFor="province">Province</label>
          <Select
            options={options}
            id="province"
            type="text"
            onChange={(option) => {
              setFormData((prevData) => ({
                ...prevData,
                province: option.value,
              }));
            }}
            required
            placeholder="Province"
            value={
              options.find((i) => i.value === formData.province) || options[0]
            }
          />
        </div>
        <div className={styles.controls}>
          <label htmlFor="country">Country</label>
          <input
            id="country"
            type="text"
            onChange={handleInputChange}
            placeholder="Country"
            value="CA-CANADA"
            disabled
          />
        </div>
      </form>
      {searchResultsModalOpen && (
        <AddressSearchResultsModal
          searchValue={searchValue}
          onSelect={handleAddressIdChange}
          onClose={() => setSearchResultsModalOpen(false)}
          open={searchResultsModalOpen}
        />
      )}
    </>
  );
}

export default DeliveryForm;
